import React from "react";
import {
    Alert,
    Box,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    TextField,
} from "@mui/material";

export default function SectionRegionen({
                                            form,
                                            setForm,
                                            regions,
                                        regionsLoading,
                                        regionsError,
                                    }) {
    const [search, setSearch] = React.useState("");
    const ids = new Set((form.region_ids || []).map(Number));

    const sorted = React.useMemo(() => {
        const q = search.trim().toLowerCase();
        return [...(regions || [])]
            .filter((item) => item.is_active !== false)
            .filter((item) => {
                if (!q) return true;
                return [
                    item.legacy_id,
                    item.name,
                    item.label_de,
                    item.label_en,
                    item.label_fr,
                    item.label_it,
                ].some((value) => String(value || "").toLowerCase().includes(q));
            })
            .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0) || String(a.label_de || "").localeCompare(String(b.label_de || ""), "de"));
    }, [regions, search]);

    const toggle = (id) => {
        setForm((f) => {
            const current = new Set((f.region_ids || []).map(Number));
            if (current.has(id)) current.delete(id);
            else current.add(id);
            return { ...f, region_ids: [...current] };
        });
    };

    if (regionsLoading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={22} />
            </Box>
        );
    }

    if (regionsError) return <Alert severity="error">{regionsError}</Alert>;

    if (!sorted.length) {
        return <Alert severity="info">Keine Regionen vorhanden. Lege zuerst Regionen in der Verwaltung an.</Alert>;
    }

    return (
        <Box>
            <TextField
                fullWidth
                size="small"
                label="Region suchen"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{ mb: 2 }}
            />
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))", lg: "repeat(3, minmax(0, 1fr))" },
                    gap: 1,
                }}
            >
                {sorted.map((region) => (
                    <FormControlLabel
                        key={region.id}
                        control={
                            <Checkbox
                                size="small"
                                checked={ids.has(Number(region.id))}
                                onChange={() => toggle(Number(region.id))}
                            />
                        }
                        label={region.label_de || region.name}
                    />
                ))}
            </Box>
        </Box>
    );
}
